<template>
  <div class="tradesman-thumblist">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input
              v-model="formItem.key"
              clearable
              placeholder="1输入匠人昵称或者图片标题查找..."
              style="width:200px"
            ></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="1200"
      :mask-closable="false"
      :styles="styles"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="选择分类">
          <Select v-model="dataInfo.cate_id" filterable clearable>
            <Option v-for="item in cateList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="标题">
          <Input v-model="dataInfo.title" placeholder="请输入标题..."></Input>
        </FormItem>-->
        <FormItem label="选择匠人" label-position="top" prop="tradesman_id">
          <Select v-model="dataInfo.tradesman_id" clearable filterable placeholder="选择匠人">
            <Option v-for="item in trandList" :value="item.id" :key="item.id">{{item.nickname}}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="标签">
          <Input v-model="dataInfo.tag" placeholder="多个用;隔开"></Input>
        </FormItem>-->
        <FormItem label="作品时间">
          <DatePicker v-model="dataInfo.time" placeholder="作品时间" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="相册" prop="album">
          <upload-thumb
            v-model="dataInfo.album"
            ref="uploadthumbTwo"
            :defaultList="thumblistTwo"
            :autoCropWidth="750" :autoCropHeight="750"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750,大小不超过2M'"
            :maxNum="100"
          ></upload-thumb>
        </FormItem>
        <FormItem label="内容">
          <Input type="textarea" v-model="dataInfo.content" :rows="3" />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="createOrUpdate('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
    <viewer
      :options="viewerOptions"
      :images="viewerImages"
      @inited="inited"
      class="viewerImageWraper"
      ref="viewerImageWraper"
    >
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper" v-for="img in viewerImages" :key="img">
            <img class="image" :src="img" :data-source="img" :alt="img" style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "tradesman-thumblist",
  data() {
    const validateTradesmanId = (rule, value, callback) => {
      if (
        this.dataInfo.tradesman_id == 0 ||
        this.dataInfo.tradesman_id == "" ||
        this.dataInfo.tradesman_id == null ||
        this.dataInfo.tradesman_id == undefined
      ) {
        callback(new Error("请选择匠人"));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumbTwo"].uploadList.length == 0) {
        callback(new Error("请上传相冊"));
      } else {
        callback();
      }
    };
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      visible: false,
      imgUrl: "",
      viewerImages: [], // v-viewer图片列表
      viewerOptions: {
        toolbar: false,
        url: "data-source"
      },
      loading: true,
      dataloading: true,
      updating: false,
      thumblist: [],
      cateList: [],
      trandList: [],
      thumblistTwo: [],
      isClear: false,
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "内容",
          key: "content",
          minWidth: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "图片",
          key: "album",
          width: 240,
          ellipsis: true,
          render: (h, params) => {
            var that = this;
            var ill = params.row.album;

            var imgListObj = new Array();
            if (ill == "" || ill == null) {
              return;
            }
            var il = ill.split(",");
            for (var i = 0; i < il.length; i++) {
              // var showImg = this.$publicData.ossUrl+this.$publicData.imageUrl + il[i];
              var showImg = this.$publicData.ossUrl + il[i];
              imgListObj.push(
                h("img", {
                  style: {
                    width: "50px",
                    height: "50px"
                  },
                  attrs: {
                    src: showImg
                  },
                  
                })
              );
            }
            return h("div", imgListObj);
          }
        },
        // {
        //   title: "标签",
        //   key: "tags",
        //   minWidth: 200
        // },

        {
          title: "分类标题",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.cate == null ? "" : params.row.cate.title
              )
            ]);
          }
        },
        {
          title: "匠人",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tradesman == "" ? "" : params.row.tradesman.nickname
              )
            ]);
          }
        },
        {
          title: "发布时间",
          key: "time",
          minWidth: 200
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginLeft: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.commentList(params.row.id);
                    }
                  }
                },
                "讨论"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showPrices: true,
      dataInfo: {
        title: "",
        time: "",
        tradesman_id: 0,
        cate_id: 0,
        tag: ""
      },
      showModalStatus: false,
      dataInfoValidate: {
        tradesman_id: [
          {
            required: true,
            validator: validateTradesmanId,
            trigger: "change"
          }
        ],
        album: [
          { required: true, validator: validateThumbTwo, trigger: "change" }
        ]
      }
    };
  },
  // 组件
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  created: function() {
    this.$api.tradesmanthumbcate.list().then(res => {
      if (res.code == 200) {
        this.cateList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
    this.getTrandList();
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    getTableList: function() {
      this.$api.tradesmanthumb
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    commentList(id) {
      this.$router.push("/tradesman/thumbcommentlist/" + id);
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        title: "",
        time: "",
        tradesman_id: 0,
        cate_id: 0,
        tag: "",
        content: ""
      };
      this.showModalStatus = !this.showModalStatus;

      this.thumblistTwo = new Array();
      // this.$refs["editContent"].editor.txt.html("");
      var d2 = new Date();
      this.dataInfo.time = this.formatDate(d2, "yyyy-MM-dd hh:mm:ss");
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.showModalStatus = !this.showModalStatus;
      this.thumblistTwo = new Array();
      this.$api.tradesmanthumb.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        // this.$refs["editContent"].editor.txt.html(res.result.content);
        if (this.dataInfo.album != null && this.dataInfo.album.length > 0) {
          for (var s in this.dataInfo.attrShow) {
            this.thumblistTwo.push({
              name: this.dataInfo.attrShow[s],
              url: this.dataInfo.attrShow[s],
              status: "finished"
            });
          }
        }
      });
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //相册
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.dataInfo.album = finalAttrs.substring(
                0,
                finalAttrs.length - 1
              );
            }
          }
          if (this.updating) {
            return;
          }
          this.updating = true;
          this.dataInfo.time = this.formatDate(
            this.dataInfo.time,
            "yyyy-MM-dd"
          );

          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.tradesmanthumb.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.dataloading = false;
              }
              this.$nextTick(() => {
                this.dataloading = true;
              });
              this.showModalStatus = !this.showModalStatus;
              setTimeout(() => {
                this.updating = false;
              }, 2000);
            });
          } else {
            this.$api.tradesmanthumb.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.dataloading = false;
              }
              this.$nextTick(() => {
                this.dataloading = true;
              });
              this.showModalStatus = !this.showModalStatus;
              setTimeout(() => {
                this.updating = false;
              }, 2000);
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.dataloading = false;
          this.$nextTick(() => {
            this.dataloading = true;
          });
        }
      });
    },
    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tradesmanthumb.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.tradesmanthumb.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    getTrandList() {
      this.$api.tradesman.list({ page: 1, size: 10000 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    formatDate(tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style scoped>
</style>
